// @ts-nocheck

// import { invList } from '../data/fence_inv.js'
// import GetFenceInv from '../utilities/getFenceInv.js'

import makeFenceObject from './makeFenceObject.js'
import { getElementArray } from './fenceCalcSupport/elementArray'
import { getNeededInvItemList } from './fenceCalcSupport/neededInvItemList'

import appUtilities from './appUtilities.js' // eslint-disable-line

export default function fenceCalc(sessionObj, invList) {
    //  convert all sessionObj values from string to int where relevant resulting in the raw fence params
    const FenceObject = makeFenceObject(sessionObj)

    const elementArray = getElementArray(FenceObject) //  FENCE ELEMENTS - given the raw fence params, what are the fence elements needs ie corners posts etc.

    const neededInvItemList = getNeededInvItemList(FenceObject, elementArray) //   INV MAP

    const materialsList = [] // array of objects. ea. object a line for grid display

    neededInvItemList.invItemMap.forEach((neededQty, neededProductID) => {
        //    GENERATE MATERIALS LIST

        const invItemObj = invList.find(
            // get the info object from stored inventory forEach neededProductID
            (item) => item.productID === neededProductID
        )
        // TODO: 05/22/23 good interception point - remove for production
        // if (invItemObj.productID === 'ITB-EB') {
        //     let r = 0
        // }

        if (!invItemObj || invItemObj.length > 1 || invItemObj.length === 0) {
            throw new Error('invList corruption')
        }

        const {
            // get the elements
            productIDNum,
            href,
            productID,
            descriptionTitle,
            pkgQty,
            srp,
            safe,
            displayOrder,
        } = invItemObj

        let lineItem = {
            // make a new object with them
            productIDNum,
            href,
            productID,
            descriptionTitle,
            pkgQty,
            srp,
            displayOrder,
        }

        const itemQty = getNumberOfPkgs(
            neededQty,
            pkgQty,
            safe,
            neededProductID
        )
        // const lineItemTotal = Money.getLineItemTotal(itemQty, srp)
        // const sugRetail = Money.getMoneyFormat(srp)

        lineItem = { ...lineItem, itemQty }
        materialsList.push(lineItem)
    })
    appUtilities.addLogging(materialsList)
    // console.log('finished a fence Calculation')

    const fenceSummaryRpt = FenceObject.generalFenceDescripRpt()
    // console.log('fenceSummaryRpt', fenceSummaryRpt)
    return { materialsList, fenceSummaryRpt }
}
// eslint-disable-next-line
function getNumberOfPkgs(neededQty, pkgQty, safe, neededProductID) {
    const measure = parseInt(pkgQty, 10)
    const safetyMargin = parseInt(safe, 10)
    const totalUnitQty = neededQty + safetyMargin

    //  if the last additional package only marginally completes safetyMargin - ignore.  If 82% saafety margin is satisfied without extra package, then go without.  save $
    let ignoreSurplusPackage = false
    if (safetyMargin) {
        const modulusQty = (neededQty + safetyMargin) % measure // is an extra pack provoked by safety margin?
        ignoreSurplusPackage = !!modulusQty && modulusQty / safetyMargin < 0.18 //  by how much then?
    }
    const itemQty = Math.ceil(totalUnitQty / measure) - ignoreSurplusPackage // to use packaging

    appUtilities.addLogging(
        `Estimation Logic auditing - Safety margin rpt - for ${neededProductID}.
        ignoreSurplusPackage calc was ${ignoreSurplusPackage}.
        The inv. safety margin qty is ${safetyMargin}
        and the estimate's unadjusted qty determination is ${neededQty}.
        Given that the pack qty is ${measure}.
        This yields a suggested qty of ${itemQty}.
        `
    )

    return itemQty
}
